import { useEffect } from "react"

import { useSearchParams } from "react-router-dom"

import { LoadingIndicator } from "components/custom/Loader"

import "react-toastify/dist/ReactToastify.css"
import { useAuth } from "hooks/useAuth"

const SwitchApp = () => {
  const { loginWithSSO } = useAuth()

  const [searchParams] = useSearchParams()

  useEffect(() => {
    const token = searchParams.get("token") || ""
    const code = searchParams.get("code") || ""
    const referrer = searchParams.get("referrer") || ""
    loginWithSSO(token, code, referrer)
  }, [])

  return (
    <div>
      <div className="z-[2] flex  items-center justify-center py-10 bg-white bg-opacity-75  h-screen absolute left-0 top-0 right-0  ">
        <div>
          <span className="mr-[10px]">Loading</span>
          <LoadingIndicator />
        </div>
      </div>
    </div>
  )
}

export default SwitchApp
